import Cookies from "js-cookie";

import { API_V2_ALLOCATIONS } from "../../../config/Endpoints.js";
import { postApi } from "../../utils/api.ts";

/** POST /api/v2/allocations — monthly, weekly, or one-time custom. */
export async function postAllocation(
  body: Record<string, unknown>,
): Promise<unknown> {
  const token = Cookies.get("accessToken");
  const { data } = await postApi<unknown>(API_V2_ALLOCATIONS, token, body);
  return data;
}
